import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { GroupMatchViewModule } from './group-match-view/group-match-view.module';
import { GroupsStoreModule } from '@libs/src/groups/groups-store/groups-store.module';
import { GroupViewModule } from '@main-client/src/app/group-view/group-view.module';

import { GroupsLegacyGuardService } from './groups-legacy-guard.service';
import { GroupsService } from './groups.service';
import { GroupsBackend } from '@libs/src/groups/groups.backend';
import { OpportunityBackend } from '@libs/src/opportunity/opportunity.backend';
import { PreregistrationLegacyGuardService } from '@main-client/src/app/sign-up/preregistration-legacy-guard.service';

import { GroupLoadedGuard } from '@main-client/src/app/groups/group-loaded.guard';
import { groupRoutes } from '@main-client/src/app/groups/groups.routes';

import { MatchesModule } from '../matches/matches.module';

@NgModule({
  imports: [
    CommonModule,
    GroupViewModule,
    GroupMatchViewModule,
    GroupsStoreModule,
    MatchesModule,
    RouterModule.forChild(groupRoutes),
  ],
  providers: [
    GroupsLegacyGuardService,
    GroupLoadedGuard,
    GroupsBackend,
    GroupsService,
    OpportunityBackend,
    PreregistrationLegacyGuardService,
  ],
})
export class GroupsModule {}
